import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

Sentry.init({
  dsn: 'https://65f79a36a7a04ba38a6f2828902788f9@sentry.io/1504872',
  integrations: [new Integrations.Vue({ Vue, attachProps: true })],
});

// import { captureMessage, captureException } from '@sentry/browser'

// captureMessage('Something went wrong')

// try {
//   aFunctionThatMightFail();
// } catch (err) {
//   captureException(err);
// }
